import { useQuery } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { patientKeys } from '@/lib/queryKeys'

export function usePatientRecord(patientId: string) {
  return useQuery({
    queryKey: patientKeys.detail(patientId),
    queryFn: () => providerApiClient.getPatientRecord(patientId),
    enabled: !!patientId,
    staleTime: 5 * 60 * 1000,
  })
}
